import type {
  IADatabaseAction,
  IADatabaseContextReducerState
} from '$ops-portal/context/ia-database-context/iaDatabase.types';
import { iaDatabaseConfigReducer } from './ia-database-config';
import type { IAConfigAction } from './ia-database-config/iaDatabaseConfig.types';
import { iaInfoReducer } from './ia-info';
import type { IAInfoDatabaseAction } from './ia-info/iaInfo.types';

export const iaDatabaseReducer = (
  { configData, iaInfo }: IADatabaseContextReducerState,
  action: IADatabaseAction
): IADatabaseContextReducerState => ({
  configData: iaDatabaseConfigReducer(configData, action as IAConfigAction),
  iaInfo: iaInfoReducer(iaInfo, action as IAInfoDatabaseAction)
});
